<template>
  <div class="zxbw">
    <header class="b-relative">
      <img src="./images/banner.jpg" alt="banner" />
    </header>
    <section>
      <van-tabs
        v-model="active"
        scrollspy
        sticky
        :offset-top="$showTitle ? 46 : 0"
      >
        <van-tab title="产品详情">
          <div class="section-main">
            <div class="cpts-list">
              <div class="cpts-item cpts-md1">
                <div class="title">
                  <h2>一份适合工作、生活、出行的综合意外险</h2>
                </div>
                <div class="cpts-item-main">
                  <img src="./images/img01.jpg" />
                </div>
              </div>

              <div class="cpts-item cpts-md2">
                <div class="title">
                  <h2>满期140%给付已交保费</h2>
                </div>
                <div class="cpts-item-main">
                  <img src="./images/img02.jpg" />
                  <ul class="md2-ul">
                    <li>
                      <p>只需交10年，<br />便可安心享有30年保障</p>
                    </li>
                    <li>
                      <p>长达30年的<br />全球紧急救援服务</p>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="cpts-item cpts-md3">
                <div class="title">
                  <h2>意外医疗最高20万</h2>
                </div>
                <div class="cpts-item-main">
                  <ul class="md3-ul">
                    <li>
                      <img src="./images/img03.jpg" />
                      <p>
                        社保范围内<span class="red">门诊住院</span><br />都能赔
                      </p>
                    </li>
                    <li>
                      <img src="./images/img04.jpg" />
                      <p>
                        最高<span class="red">每年赔2万</span
                        ><br />保险期间<span class="red">最高赔付20万</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="cpts-item cpts-md4">
                <div class="title">
                  <h2>意外身故最高赔付<br />200万+140%已交保费</h2>
                </div>
                <div class="cpts-item-main">
                  <ul class="md4-ul">
                    <li>
                      <img src="./images/img05.jpg" />
                      <p>意外伤残<br />最高赔付<span class="red">20万</span></p>
                    </li>
                    <li>
                      <img src="./images/img06.jpg" />
                      <p>
                        意外身故最高赔付<br /><span class="red"
                          >200万+140%已交保费</span
                        >
                      </p>
                    </li>
                    <li>
                      <img src="./images/img07.jpg" />
                      <p>
                        非意外身故赔付<br /><span class="red">140%</span
                        >已交保费
                      </p>
                    </li>
                  </ul>
                  <p class="explain">
                    这款尊享百万畅行意外险，买给自己或家人需要多少钱？
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="投保须知">
          <div class="product-instruction">
            <div class="section-title">
              <h3 class="title">投保须知</h3>
            </div>
            <div class="section-main">
              <table class="product-instable">
                <tbody>
                  <tr>
                    <th>产品名称</th>
                    <td>尊享百万畅行意外伤害保险产品计划</td>
                  </tr>
                  <tr>
                    <th>被保人年龄</th>
                    <td>出生满28天至55周岁</td>
                  </tr>
                  <tr>
                    <th>保险期间</th>
                    <td>30年</td>
                  </tr>
                  <tr>
                    <th>投保范围</th>
                    <td>
                      本人、配偶、父母、子女
                    </td>
                  </tr>
                  <tr>
                    <th>缴费年限</th>
                    <td>
                      10年
                    </td>
                  </tr>
                  <tr>
                    <th>保障金额</th>
                    <td>1-20万</td>
                  </tr>
                  <tr>
                    <th>交费方式</th>
                    <td>年交/半年交/季交/月交</td>
                  </tr>
                  <tr>
                    <th>产品条款</th>
                    <td>
                      <a
                        :href="require('../../common/tiaokuan/baiwanshouhuliangquanbaoxian.pdf')"
                        target="_blank" @click="pdfPreview($event)"
                        >招商信诺百万守护两全保险</a
                      ><br />
                      <a
                        :href="require('../../common/tiaokuan/fujiabaiwangshouhuyiwaishanghaibaoxianBkuan.pdf')"
                        target="_blank" @click="pdfPreview($event)"
                        >招商信诺附加百万守护意外伤害保险B款</a
                      ><br />
                      <a
                        :href="require('../../common/tiaokuan/bwshyiwaishanghai.pdf')"
                        target="_blank" @click="pdfPreview($event)"
                        >招商信诺附加百万守护意外伤害医疗保险</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>投保地区</th>
                    <td id="fname">
                      广东、北京、上海、江苏、浙江、山东、四川、重庆、湖北、陕西、辽宁、湖南、河南、江西、天津、安徽、福建（不含厦门）
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="reminder">
                温馨提示：本网页仅供参考，不构成保险合同组成部分，保险责任、责任免除、等待期、理赔要求等重点内容，以条款为准。
              </p>
            </div>
          </div>
        </van-tab>
        <van-tab title="理赔流程">
          <CustomerServiceGuide />
        </van-tab>
      </van-tabs>
    </section>
    <router-link to="" tag="footer">
      <button class="btn" :class="{ disabled: LGStatus }" @click="sendLG(2)">{{ LGStatus ? "已预约" : "联系专属顾问" }}</button>
    </router-link>
  </div>
</template>

<script>
import mixin from "../../common/mixin.js";
import CustomerServiceGuide from "../../common/customer-service-guide/CustomerServiceGuide.vue";
export default {
  mixins: [mixin],
  components: { CustomerServiceGuide },
  data() {
    return { 
      active: 0 ,
      code:'1GZ1DO0501BDRPAY1',
      productName:'尊享百万畅行意外伤害保险产品计划',
      method1:14,
      method2:6
    };
  },
};
</script>
<style>
.zxbw .van-tabs__wrap {
  border-bottom: 1px solid #d0d0d0;
}
.zxbw .van-tabs {
  background: #f6f6f6;
  box-sizing: border-box;
}
.zxbw .van-tab {
  font-size: 0.14rem;
  color: #363636;
}
.zxbw .van-tab--active {
  font-size: 0.14rem;
  color: #3aaaf8;
}
.zxbw .van-tabs__line {
  width: 0.85rem;
  background: #3aaaf8;
}
.zxbw .van-tabs__content {
  background: white;
}
.zxbw .head-btn .van-icon {
  top: 0.0134rem;
}
</style>
<style scoped>
.zxbw {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: #2d2e2f;
}
img {
  width: 100%;
}
.cpts-list {
  padding: 0.1rem 0.15rem 0.25rem;
  background: #7abd59;
}
.cpts-item {
  position: relative;
  margin-top: 0.35rem;
  padding-top: 0.45rem;
  padding-bottom: 0.15rem;
  background: #fff;
  text-align: center;
  border-radius: 0.1rem;
  box-shadow: 0 0.05rem 0.1rem rgba(159, 189, 89, 0.53),
    inset 0 0 0.8rem rgba(159, 189, 89, 0.5);
}
.cpts-item .title {
  position: absolute;
  left: 50%;
  top: -0.17rem;
  width: 3rem;
  height: 0.46rem;
  transform: translateX(-50%);
  background: url(./images/titlebg.png) no-repeat center;
  background-size: 3rem 0.46rem;
}
.cpts-item .title h2 {
  font-size: 0.18rem;
  color: #fff;
  font-weight: bold;
  line-height: 0.45rem;
  text-shadow: 0.02rem 0.02rem 0.05rem #ff943d;
}
.cpts-md1 .title h2 {
  font-size: 0.14rem;
}
.cpts-md1 img {
  width: 3rem;
}
.cpts-md2 img {
  max-width: 2.2rem;
}
.md2-ul {
  margin-top: 0.15rem;
  margin-left: 0.25rem;
  overflow: hidden;
}
.md2-ul li {
  float: left;
  width: 40%;
  text-align: left;
  font-size: 0.12rem;
  color: #333;
  line-height: 0.22rem;
  text-indent: 0.2rem;
  background: url(/img/icon_dui.a1973ac4.png) no-repeat left top 0.03rem;
  background-size: 0.17rem;
}
.md2-ul li:first-child {
  width: 55%;
}

.red {
  color: #f9531c !important;
}
.md3-ul {
  overflow: hidden;
  margin: 0.15rem;
}
.md3-ul li {
  float: left;
  width: 50%;
}
.md3-ul li img {
  width: 0.9rem;
  margin-bottom: 0.1rem;
}
.md3-ul li p {
  font-size: 0.12rem;
  color: #333;
  line-height: 0.16rem;
}

.cpts-md4 .title h2 {
  line-height: 0.22rem;
  font-size: 0.15rem;
}
.md4-ul {
  overflow: hidden;
  margin-bottom: 0.15rem;
}
.md4-ul li {
  float: left;
  width: 28%;
  color: #333;
  line-height: 0.16rem;
}
.md4-ul li:nth-child(2) {
  width: 44%;
}
.md4-ul li img {
  width: 0.7rem;
  margin-bottom: 0.2rem;
}
.anchor-btn {
  display: block;
  font-size: 0.15rem;
  color: #fff;
  line-height: 0.3rem;
  text-align: center;
  width: 2rem;
  background: linear-gradient(#fe712a, #fd4b01);
  border-radius: 0.14rem;
  margin: 0.1rem auto;
}
.cpts-md4 .explain {
  font-size: 0.12rem;
  color: #555;
  line-height: 0.2rem;
}
/* 按钮 */
footer {
  padding: 0 0.15rem;
}
.btn {
  width: 100%;
  height: 0.37rem;
  background: #3b97ff;
  border-radius: 0.37rem;
  line-height: 0.37rem;
  border: none;
  font-size: 0.15rem;
  font-weight: bold;
  color: #ffffff;
  margin: 0.3rem 0;
  box-shadow: 0rem 0.03rem 0.05rem #3b97ff;
}
.btn.disabled {
  filter: grayscale(1);
}


.product-instruction {
  margin-top: 0.1rem;
  background: #fff;
}
.section-title {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
}
.section-title .title {
  font-size: 0.16rem;
  color: #333;
  line-height: 0.2rem;
  font-weight: bold;
}
.product-instruction .section-main {
  padding: 0.15rem 0.15rem 0.3rem;
}
.product-instable {
  margin-bottom: 0.15rem;
  border: 1px solid #eee;
  width: 100%;
  font-size: 0.13rem;
  line-height: 0.2rem;
  border-collapse: collapse;
  border-spacing: 0;
}
.product-instable th {
  padding: 0.1rem 0.1rem;
  width: 30%;
  color: #777;
  background: #f5f5f5;
  border: 1px solid #fff;
  font-weight: normal;
}
.product-instable td {
  padding: 0.1rem 0.05rem 0.1rem 0.15rem;
  width: 70%;
  border: 1px solid #eee;
}
.product-instable a {
  color: #3aaaf8;
}
.product-instruction .reminder {
  font-size: 0.11rem;
  color: #999;
}
</style>
